module.exports = __webpack_public_path__ + "img/BlinkArt_Shield_Medium.6cf1b1db.png";